import Feeders from './feeders';
import { Route } from 'types/route.type';

export const routes: Route[] = [
  {
    path: '/self-service/feeders/',
    component: Feeders,
    id: 'selfService.feeders.title',
  },
];
